<template>
  <button
    class="btn"
    :class="rootClasses"
    :disabled="disabled"
    :data-ua-unique-id="dataUaUniqueId"
  >
    <lp-icon
      v-if="icon"
      class="lp-btn-icon"
      :name="icon"
      :compact="!hasLabel"
      :class="hasLabel && !iconAfter && 'xmr-2'"
    />
    <span v-if="hasLabel" class="lp-btn-text" :class="loading && 'xmr-2'">
      <slot>{{ label }}</slot>
    </span>
    <span class="lp-btn-wrap-loading">
      <lp-loading
        v-if="loading"
        :color="loadingColor"
        :radius="10"
        :stroke="3"
      />
    </span>
  </button>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { Sizes, Colors } from '@/models/enums'
import { colorType } from '@/models/types'
import { iconType } from '@/components/icon/iconTypes'
defineOptions({
  name: 'lp-button',
})
interface Props {
  type?: colorType
  size?: Sizes
  iconAfter?: boolean
  disabled?: boolean
  outlined?: boolean
  round?: boolean
  pulse?: boolean
  loading?: boolean
  loadingColor?: string
  block?: boolean
  text?: boolean
  link?: boolean
  icon?: iconType | null
  label?: string | null
  dataUaUniqueId?: string
}
const props = withDefaults(defineProps<Props>(), {
  type: Colors.NEUTRAL,
  size: Sizes.NORMAL,
  icon: null,
  label: null,
  loadingColor: 'var(--white)',
  dataUaUniqueId: 'ua-lp-button',
})
const slots = useSlots()

const rootClasses = computed(() => [
  {
    pulse: props.pulse,
    'lp-btn--empty': !hasLabel.value,
    'btn-block': props.block,
    'btn-noborder': props.text,
    'btn-link': props.link,
    'lp-btn--loading': props.loading,
    [`btn-${props.size}`]: props.size,
    ...(props.type ? { [`btn-${props.type}`]: true } : { '': true }),
    ...(props.icon
      ? {
          [props.iconAfter ? 'btn-icon-after' : 'btn-icon-before']: true,
        }
      : null),
  },
])

const hasLabel = computed(() => slots.default || props.label)
</script>
